import {SET_SHEETS_VIDEOS_MODAL_BUTTON, SET_SHOW_SHEETS_ACCUEIL} from "../actions/SheetsVideosFormations";

export const initialState = {
    showSheetsList: false,
    sheetsVideosModalButton: false,
    showSheetsAccueil: false
};

const sheetsvideosformations = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_SHOW_SHEETS_ACCUEIL : {
            return {
                ...state,
                showSheetsAccueil: action.bool,
            };
        }
        case SET_SHEETS_VIDEOS_MODAL_BUTTON : {
            return {
                ...state,
                sheetsVideosModalButton: action.bool
            };
        }
        default:
            return state;
    }
};

export default sheetsvideosformations;